export const RouteOwnCollectStatusEnum = {
  COLETADOR_NAO_ATENDIDO: {
    id: 1,
    message: "A coleta não pode ser efetuada - Coletador não atendido",
    name: "Coletador não atendido"
  },
  CLIENTE_DESCONHECIDO: {
    id: 2,
    message: "A coleta não pode ser efetuada - Cliente desconhecido no local",
    name: "Cliente desconhecido"
  },
  CLIENTE_MUDOU: {
    id: 3,
    message: "A coleta não pode ser efetuada - Cliente mudou-se",
    name: "Cliente mudou-se"
  },
  CLIENTE_RECUSOU: {
    id: 4,
    message: "A coleta não pode ser efetuada - Cliente recusou-se a entregar a coleta",
    name: "Cliente recusou a coleta"
  },
  CLIENTE_SEM_DOCUMENTO: {
    id: 5,
    message: "A coleta não pode ser efetuada - Destinatário não apresentou documento exigido",
    name: "Cliente sem documento"
  },
  EMPRESA_SEM_EXPEDIENTE: {
    id: 6,
    message: "A coleta não pode ser efetuada - Empresa sem expediente",
    name: "Empresa sem expediente"
  },
  ENDERECO_INCORRETO: {
    id: 7,
    message: "A coleta não pode ser efetuada - Endereço incorreto",
    name: "Endereço incorreto"
  },
  ENDERECO_COM_NUMERACAO_IRREGULAR: {
    id: 8,
    message: "A coleta não pode ser efetuada - Logradouro com numeração irregular",
    name: "Numeração irregular"
  },
  EXTRAVIADO: {
    id: 9,
    message: "Coleta Extraviada",
    name: "Coleta extraviada"
  },
  COLETADO: {
    id: 11,
    message: "Coleta realizada",
    name: "Coleta realizada"
  },
  PENDENTE: {
    id: 12,
    message: "Pendente",
    name: "Coleta pendente"
  },
  EM_ROTA_DE_COLETA: {
    id: 13,
    message: "O Coletador está em rota de coleta",
    name: "Em rota de coleta"
  },
  COLETADOR_NAO_FINALIZOU_COLETA: {
    id: 14,
    message: "A coleta não pode ser efetuada - O coletador não finalizou a coleta",
    name: "Coleta não finalizada"
  },
  AREA_DE_RISCO: {
    id: 15,
    message: "A coleta não pode ser efetuada - Área de risco",
    name: "Coleta em área de risco"
  },
  CONDICOES_CLIMATICAS_ADVERSAS: {
    id: 24,
    message: "A coleta não pode ser efetuada - Condições climáticas adversas",
    name: "Condições climáticas adversas"
  },
  ERRO_NA_ROTEIRIZACAO: {
    id: 25,
    message: "A coleta não pode ser efetuada - Erro na roteirização",
    name: "Erro na roteirização"
  },
};

